import { LANG_INTERFACE } from '../../constants/lang/lang-interface.constant'
import { hidden }         from '../button/button.class.scss'

//Mobile close button data URI
import * as close from '../../assets/mobile/mb-pt-btn-close.svg'


/**
 * @file Defines the {@link Interface} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling functionality of an interface
  */
  export class Interface {
  
      /**
       * Flag for whether click events have been added for close buttons.
       * @memberof Interface
       * @protected
       * @instance
       * @type {boolean}
       */
      _added

      /**
       * ID of interface.
       * @memberof Interface
       * @private
       * @instance
       * @type {string}
       */
      _id

      /**
       * Flag for whether bet interface should be shown.
       * @memberof Interface
       * @protected
       * @instance
       * @type {boolean}
       */
      _show
  
      /**
       * Initialise interface
       * @param id_ - ID of close button
       */
      constructor(id_) {

          this._id   = id_   //Store ID
          this._show = false //Hide interface initially

          //On mobile touchstart
          document.getElementById(`${id_}ContainerMobile`).addEventListener('touchstart', e_ => {

            let parentID = e_.target.parentNode.id //Store ID of parent element

            //If user clicks on anything other than a button/control in interface
            if (parentID === `${id_}ContainerMobile` || parentID === `${id_}-body` || parentID === 'body-settings' || parentID === 'mb-pt-close') {

                this.click(this)    //Hide interface
                e_.preventDefault() //Prevent click event going through to main buttons

            }

          })

          this.translate(id_) //Translate interface texts

      }
  
      /** Get show */ get show() { return this._show }
      /** Set show */ set show(v_) { this._show = v_ }

      /** Handles rendering interface in the DOM */
      render() {
        this._show ? document.getElementById(`${this._id}ContainerMobile`).classList.remove(hidden) : document.getElementById(`${this._id}ContainerMobile`).classList.add(hidden)
      }
  
      /**
       * Click handler for toggling interface
       * @param {object} this_ - Reference to class's scope
       */
      click(this_) {
  
          let _this = this_ //Store reference to scope

          //For each button
          window.newUI.buttons.forEach(b_ => {

              b_.enable  = true //Enable button
              b_.visible = true //Make button visible

          })
  
      }

      /**
       * Adds top button to interface
       * @param {string} id_ - ID of interface to add close button to
       */
      topButton(id_) {

        let elem = new DOMParser().parseFromString(close, 'text/xml')             //Parse SVG string
        document.getElementById(`${id_}-close`).appendChild(elem.documentElement) //Add asset to close button

      }
  
      /** 
       * Handles displaying text in interface
       * @param {string} id_ - ID of interface
       */
      translate(id_) {
  
          let texts = LANG_INTERFACE[id_] //Store texts for interface

          //For each text in interface
          for (let id in texts) {
            document.getElementById(id).innerHTML = Translate.do(texts[id]) //Add translated text to interface
          }
  
      }
  
  }